cb.viewmodels.register('PlatformManagementViewModel', function (modelType) {
  var model = function (data) {
    cb.models.ContainerModel.call(this, data);
    this.init();
  };
  model.prototype = cb.utils.getPrototype(cb.models.ContainerModel.prototype);
  model.prototype.modelType = modelType;

  model.prototype.init = function () {
    var fields = {
      cacheType: new cb.models.ListModel({ enumArray: "[{\"nameType\":\"text\",\"value\":\"菜单\",\"key\":\"menu\"},{\"nameType\":\"text\",\"value\":\"权限\",\"key\":\"auth\"},{\"nameType\":\"text\",\"value\":\"按钮权限\",\"key\":\"actionAuth\"},{\"nameType\":\"text\",\"value\":\"规则\",\"key\":\"rule\"},{\"nameType\":\"text\",\"value\":\"选项\",\"key\":\"option\"},{\"nameType\":\"text\",\"value\":\"枚举\",\"key\":\"enum\"},{\"nameType\":\"text\",\"value\":\"ViewModel\",\"key\":\"viewmodel\"}]" }),
      refreshCache: new cb.models.SimpleModel(),
      upgradeUserDef: new cb.models.SimpleModel(),
    bpmInit: new cb.models.SimpleModel(),
    enumUpgrade: new cb.models.SimpleModel(),
        uninstall: new cb.models.SimpleModel(),
        uninstallDate: new cb.models.SimpleModel(),
    };
    this.setData(fields);
    this.setDirty(false);

    this.get('refreshCache').on('click', function (args) {
      PlatformManagementViewModel_Extend.refreshCache(this.getParent(), args);
    });
    this.get('upgradeUserDef').on('click', function (args) {
      PlatformManagementViewModel_Extend.upgradeUserDef(this.getParent(), args);
    });
	this.get('bpmInit').on('click', function (args) {
      PlatformManagementViewModel_Extend.bpmInit(this.getParent(), args);
    });
    this.get('enumUpgrade').on('click', function (args) {
      PlatformManagementViewModel_Extend.enumUpgrade(this.getParent(), args);
    });
    this.get('uninstall').on('click', function (args) {
      PlatformManagementViewModel_Extend.unInstall(this.getParent(), args);
    });
    this.initData();
  };

  model.prototype.initData = function () {
    if (typeof PlatformManagementViewModel_Extend == 'object')
      PlatformManagementViewModel_Extend.doAction('init_Extend', this);
  };

  return model;
});

var PlatformManagementViewModel_Extend = {
  doAction: function (name, viewModel) {
    this[name](viewModel);
  },
  init_Extend: function (viewModel) {
    var proxyConfig = cb.rest.DynamicProxy.create({
      refreshCache: { url: 'cache/refreshCache', method: 'GET' },
      upgradeUserDef: { url: 'aa/userDef/upgradeBillUserDef', method: 'GET' },
      bpmInit: { url: 'bpm/init', method: 'GET' },
      enumUpgrade: { url: 'enum/upgradeEnum', method: 'GET' },
        dataUnload: { url: 'bill/dataUnload', method: 'POST' },
    });
    viewModel.setProxy(proxyConfig);
  },
  refreshCache: function (viewModel, args) {
    var types = viewModel.get('cacheType').getValue();
    viewModel.getProxy().refreshCache({ types: types.join(',') }, function (err, result) {
      if (err) {
        cb.utils.alert(err.message, 'error');
        return;
      }
      cb.utils.alert('刷新缓存成功', 'success');
    });
  },
  upgradeUserDef: function (viewModel, args) {
    viewModel.getProxy().upgradeUserDef(function (err, result) {
      if (err) {
        cb.utils.alert(err.message, 'error');
        return;
      }
      cb.utils.alert('表单自定义项升级成功', 'success');
    });
  },
  bpmInit: function (viewModel, args) {
    viewModel.getProxy().bpmInit(function (err, result) {
      if (err) {
        cb.utils.alert(err.message, 'error');
        return;
      }
      cb.utils.alert('审批流初始化成功', 'success');
    });
  },
  enumUpgrade: function (viewModel, args) {
    viewModel.getProxy().enumUpgrade(function (err, result) {
      if (err) {
        cb.utils.alert(err.message, 'error');
        return;
      }
      cb.utils.alert('枚举升级成功', 'success');
    });
  },
  unInstall: function (viewModel, args) {
    cb.utils.confirm("1. 请确保数据库磁盘可用空间>40%！！！" +
        "2. 请确保aa_dataunload中待卸载数据库表status=0！！！" +
        "3. 请检查待卸载表中的日期是否为空！！！" +
        "【select * from rm_retailvouch where dDate is null ORDER BY create_time desc;" +
        " select * from rm_gatheringvouch where dDate is null ORDER BY create_time desc;" +
        " select * from rm_daily_report where iBusinessDate is null ORDER BY dsavedate desc; " +
        " select * from rm_gathering_daily_report where busidate is null ORDER BY vouchDate desc; 】" +
        "4. 卸载数据耗时较长，可能导致数据库挂起，请慎重！！！" +
        "5. 确定要卸载选中日期之前的数据？", function () {
      var uninstallDate = viewModel.get('uninstallDate').getValue();
      viewModel.getProxy().dataUnload({hotdate: uninstallDate}, function (err, result) {
          if (err) {
              cb.utils.alert(err.message, 'error');
              return;
          }
          cb.utils.alert('开始异步卸载，请等待……', 'success');
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/yxyweb/client/common/platformManagementViewModel.js